import * as React from 'react';

import { useToast } from '@rematter/ui-web/hooks';

import { BookingFormState } from '../../../types/booking';

import { DefaultTranslations } from '~/modules/trade/i18n/useTranslations';

export const useValidateBookingContainersStep = () => {
  const toast = useToast();
  const validateContainersStep = React.useCallback(
    (
      formData: BookingFormState,
      isDraft = false,
      t?: DefaultTranslations,
    ): Record<string, string> => {
      const errors: Record<string, string> = {};

      const validContainers = formData.containers?.filter(
        (container) => container.containerType?.id || container.quantity > 0,
      );

      if (!validContainers || validContainers.length === 0) {
        if (isDraft) {
          return {};
        }
        toast.error('At least one container is required');
        return {
          containers: 'At least one container is required',
        };
      } else {
        // Validate each container
        validContainers.forEach((container, index) => {
          if (!container.quantity || container.quantity <= 0) {
            errors[`container_${index}_quantity`] = t
              ? t.bookingsView.form.fields.containersAmount +
                ' must be greater than 0'
              : 'Container quantity must be greater than 0';
          }
          if (!container.containerType?.id) {
            errors[`container_${index}_containerType`] = t
              ? t.bookingsView.form.fields.containerType + ' is required'
              : 'Container type is required';
          }
        });
      }

      return errors;
    },
    [toast],
  );

  return {
    validateContainersStep,
  };
};
